var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4FC9DA",
    d: "M24,4H4A3,3,0,0,0,1,7V21a2.87,2.87,0,0,0,.28,1.25,1,1,0,0,0,.76.56h.14a1,1,0,0,0,.75-.34l7-7.93,3.87,4.83a1,1,0,0,0,1.43.13L19,16.32l3.34,2.86a1,1,0,0,0,1.05.16,3.94,3.94,0,0,1,2.4-.26,1,1,0,0,0,1.2-1V7A3,3,0,0,0,24,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30a6b6",
    d: "M23.64,17.66l-4-3.42a1,1,0,0,0-1.3,0l-3.61,3.09-4-5A1,1,0,0,0,10,12a1,1,0,0,0-.77.34L1.43,21.16a1,1,0,0,0-.16,1.07A3,3,0,0,0,4,24H20a1,1,0,0,0,1-1,4,4,0,0,1,1.17-2.83,3.89,3.89,0,0,1,1.22-.83,1,1,0,0,0,.26-1.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.54,26.54a5,5,0,0,1-7.08-7.08,4.89,4.89,0,0,1,1.53-1,5,5,0,0,1,5.55,1A5,5,0,0,1,28.54,26.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#968e7e",
    d: "M25,29a6,6,0,0,1-4.25-10.24,6,6,0,0,1,8.49,0,6,6,0,0,1,0,8.49h0A6,6,0,0,1,25,29Zm0-10a4,4,0,0,0-2.82,1.17,4,4,0,0,0,0,5.67,4,4,0,1,0,5.66-5.67,3.9,3.9,0,0,0-2-1.08A4,4,0,0,0,25,19Zm3.55,7.54h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#968e7e",
    d: "M21.46,27.54a1,1,0,0,1-.71-1.71l7.07-7.07a1,1,0,0,1,1.41,1.41l-7.07,7.07A1,1,0,0,1,21.46,27.54Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 2,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.5b9c4bdf015e34662aeeae8c1629fdaf.svg";
export { ForwardRef as ReactComponent };